import { css, cva, cx } from '@/styled-system/css';

const frostedActionGlassRecipe = cva({
  base: {
    backdropFilter: 'blur(token(sizes.listingCard.actions.backdropBlur))',
    isolation: 'isolate',
    _before: {
      content: '""',
      inset: 0,
      opacity: 'listingCardActionsBackdrop',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 'zIndexBase',
    },
  },
  variants: {
    surface: {
      adaptive: {
        _before: {
          backgroundColor: 'bg.neutral',
        },
      },
      fixed: {
        _before: {
          backgroundColor: 'bg.neutral-fixed',
        },
      },
    },
  },
});

export const frostedActionGlass = frostedActionGlassRecipe({ surface: 'fixed' });
export const adaptiveFrostedActionGlass = frostedActionGlassRecipe({ surface: 'adaptive' });

const frostedActionPill = css({
  borderRadius: 'pill',
  paddingBlock: 'tightest',
  paddingInline: 'tightest',
  _before: {
    borderRadius: 'pill',
  },
});

export const frostedActionSurface = cx(frostedActionGlass, frostedActionPill);
export const adaptiveFrostedActionSurface = cx(adaptiveFrostedActionGlass, frostedActionPill);
